export const ALL_POSITIONS = 'ALL_POSITION';
export const ALL_SKILLS = 'ALL_SKILL';

export const POSITION_SELECTED = 'POSITION_SELECTED';
export const SKILL_SELECTED = 'SKILL_SELECTED';